<!-- 首页版块宣传纪念文章列表组件 -->
<template>
  <div class="article-block-wrap">    
      <BlockName 
        :blockName="blockItem.name"
        :url="'/xuanchuan?tab='+blockItem.alias"></BlockName>
      <div v-if="blockItems.length > 0" class="article-list">
        <div v-for="(item, index) in blockItems" class="article-item"
          :key="item.id"
          @click="handleBlockItem(item)">
            <el-image v-if="index === 0"
                    class="book-cover"
                    style="width:120px; height: 80px;"                  
                    :src="item.image == null ? require('@/assets/img/default-cover.jpg') : item.image"
                    fit="cover"></el-image>
            <span >{{ item.title }}</span>
        </div>      
      </div>
      <div v-else class="article-list">
        <el-empty :image-size="50"></el-empty>
      </div>    
  </div>
</template>

<script>
  import BlockName from './blockname.vue';
  import { getBlockItemList } from "@/api/content";  

  export default {
    components: { BlockName },
    props: {
      blockItem: {
        type: Object,
        default: ()=>({})
      }  
    },
    data() {
        return {
          blockItems: [],          
        };
      },
    methods: {
      getDataList(){
          getBlockItemList(0, this.blockItem.alias, 3).then(result => {
                if(result.code == 0){
                    if(result.data != null){
                      this.blockItems = result.data;                      
                    }                                 
                }else{
                    this.blockItems = [];
                }                   
                
                //console.log(result.data.list);            
            });
        },

        handleBlockItem(item){   
          let routeData = this.$router.resolve({
              path: '/article',
              query:{
                id: item.articleId,
              }
            });
          window.open(routeData.href, '_blank');
        },      
        
    },
    created() {     
      this.getDataList();
    },
    destroyed(){
        
      },
    mounted(){
      
    },
  };
</script>

<style scoped>
.article-block-wrap{
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  flex-direction: row;
  padding: 0px 16px 16px 16px;
  /*gap: 20px;*/
  flex-grow: 1;
  background: #FFFFFF;  
  height: 100%;  
  box-sizing: border-box;
}

.article-list{
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  flex-direction: column;
  padding: 20px 0px 0px 0px;
  flex-grow: 1;
  margin-left: 20px;
}

.article-item{
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 12px 5px;
  /*gap: 12px;*/
  align-self: stretch;
  box-sizing: border-box;
  border-width: 0px 0px 1px 0px;
  border-style: solid;
  border-color: #D8DCE2;
  cursor: pointer;
  box-sizing: border-box;  
  -webkit-transition: color,0.5s;
  transition: color,0.5s;
}

.article-item:hover{
  background: #014289;
  color: #fff;
}

.book-cover{
    flex: 0 0 80px;
    height: 80px;
    margin-right: 10px;
  }

.article-item span{
  font-size: 14px;
  font-weight: normal;
  line-height: 24px;
  letter-spacing: 0em;
  color: #000000;
}
.article-item:hover span{
  color: #fff;
}
@media screen and (max-width: 1000px){  
  .article-block-wrap{
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    flex-direction: column;
    padding: 0px 16px;      
    
  }
  .article-list{
    padding: 0 0 5px 10px;
    margin-left: 10px;
  }
  
}
@media screen and (max-width: 800px){  
  
  .article-block-wrap{
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    flex-direction: column;
    padding: 0px 10px;     
    margin: 0 5px 0 0;    
  }
  .article-list{   
    margin-left: 10px;
  }
  .article-item{
    padding: 8px 0px;
  }
  .book-cover{
    display: none;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/blocks/memoryblock/articleblock.vue